import { render, staticRenderFns } from "./ExamRoom.vue?vue&type=template&id=5a861c87"
import script from "./ExamRoom.vue?vue&type=script&lang=js"
export * from "./ExamRoom.vue?vue&type=script&lang=js"
import style0 from "./ExamRoom.vue?vue&type=style&index=0&id=5a861c87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports